import cn from "classnames";

interface LogoProps {
  size?: string | number;
  color?: string;
  className?: cn.Argument;
}

export const Logo = ({
  size = "999px",
  color = "#5514B4",
  className,
}: LogoProps) => (
  <svg
    version="1.1"
    id="bt_logo"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={size}
    height={size}
    viewBox="0 0 999 999"
    enableBackground="new 0 0 999 999"
    xmlSpace="preserve"
    className={cn(className)}
  >
    <g transform="translate(199.5 -139.84)">
      <path
        fill={color}
        d="M300,139.8c-275.9,0-499.5,223.6-499.5,499.5c0,275.9,223.6,499.5,499.5,499.5   c275.9,0,499.5-223.7,499.5-499.5S575.8,139.8,300,139.8z M299.8,201.4c242.2,0,438.5,196.3,438.5,438.5s-196.3,438.5-438.5,438.5   S-138.7,882-138.7,639.9S57.6,201.4,299.8,201.4L299.8,201.4z"
      />
      <path
        fill={color}
        d="M51,468.6v340.1h138.4c62.9,0,111.2-39.3,111.2-101.5c0-54.8-42.8-75.8-42.8-75.8s32.9-21,32.9-67.6   c0-54.2-42.8-95.2-105.9-95.2L51,468.6L51,468.6z M127.6,535h40.9c29.1,0,41.7,14.9,41.7,33.4c0,20-14.4,32.7-39.8,32.7h-42.8V535z    M127.6,669.2h40.9c29.1,0,41.7,14.9,41.7,33.4c0,20-14.4,32.7-39.8,32.7h-42.8V669.2z"
      />
      <path
        fill={color}
        d="M403.3,807.6v-261h-76.5v-78.6h238v78.6H485v261H403.3z"
      />
    </g>
  </svg>
);
